import * as React from 'react';
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip, Rectangle } from 'recharts';
import NoDataChart from './NoDataChart';
import ConsumptionChartTooltip from './ConsumptionChartTooltip';


function getYAxisWidth(data) {
    const maxCharWidth = 7;
    return (data ? Math.max(...data?.chartData.map(obj => String(Math.max(obj.moneyPerInteractions, obj.moneyPerIndexing)).length)) : 0) * maxCharWidth;
}

function CustomizedAxisTick({ payload, x, y, index }) {
    if (index === 0 || index === 5) {
        return <g></g>;
    } else {
        return <g transform={`translate(${x},${y})`}>
            <text x={0} y={0} dy={16} textAnchor="middle"
                className="recharts-cartesian-axis-tick-value">
                {payload.value}
            </text>
        </g>;
    }
}

export function ConsumptionChart({ data }) {
    const maxDataLabelLength = data ? Math.max(...data?.chartData.map(obj => String(obj.moneyPerInteractions).length)) : 0;

    return <div className="consumption-chart">
        {data?.chartData?.length > 0 ?
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    width={500}
                    height={300}
                    data={data?.chartData}
                    barGap={1}
                    margin={{
                        top: 20,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="1 3" vertical horizontal />
                    <XAxis
                        dataKey="date"
                        interval={5}
                        // @ts-ignore
                        tick={<CustomizedAxisTick />} />
                    <YAxis
                        width={getYAxisWidth(data)}
                        type="number"
                        allowDecimals={false}
                    />
                    <Tooltip cursor={{ fill: '#5b749133', stroke: 'transparent' }} content={<ConsumptionChartTooltip />} />
                    <Bar dataKey="interValue" fill="#00cfff" />
                    <Bar dataKey="indexValue" fill="#006dea" />
                    <Bar dataKey="cost" fill="#ffa600" />
                </BarChart>
            </ResponsiveContainer> :
            <NoDataChart data={data} emptyRows={4} />}
    </div>;
}